const useTitle = title => {
  const defaultTitle = 'VSap Dispatch Web'
  title ? document.title = title + ' | '+defaultTitle : document.title = defaultTitle 
};

export default useTitle